export default __webpack_public_path__ + "static/media/12n.7318717c.svg";